import { css } from "@compiled/react";

import SimpleImageTextSide from "../../wpl/simple-image-text-side/src";

export interface PatternThreeAlternatingImageTextProps {
    backgroundColor?: string;
    backgroundImage?: string;
    horizontalRuleColor?: string;
    imageWidth?: string;
    rowLayoutPadding?: string;

    imageTextSideRowOnePadding?: string;
    imageTextSideRowOnePaddingBelowLargeScreen?: string;
    rowOneHeader: string | React.ReactNode;
    rowOneBody: string | React.ReactNode;
    rowOneImageLink: string;
    rowOneImageAltText: string;

    imageTextSideRowTwoPadding?: string;
    imageTextSideRowTwoPaddingBelowLargeScreen?: string;
    rowTwoHeader: string | React.ReactNode;
    rowTwoBody: string | React.ReactNode;
    rowTwoImageLink: string;
    rowTwoImageAltText: string;

    imageTextSideRowThreePadding?: string;
    imageTextSideRowThreePaddingBelowLargeScreen?: string;
    rowThreeHeader: string | React.ReactNode;
    rowThreeBody: string | React.ReactNode;
    rowThreeImageLink: string;
    rowThreeImageAltText: string;
}

const ThreeAlternatingImageText = ({
    backgroundColor,
    backgroundImage,
    horizontalRuleColor,
    imageWidth,
    rowLayoutPadding,
    imageTextSideRowOnePadding,
    imageTextSideRowOnePaddingBelowLargeScreen,
    rowOneHeader,
    rowOneBody,
    rowOneImageLink,
    rowOneImageAltText,
    imageTextSideRowTwoPadding,
    imageTextSideRowTwoPaddingBelowLargeScreen,
    rowTwoHeader,
    rowTwoBody,
    rowTwoImageLink,
    rowTwoImageAltText,
    imageTextSideRowThreePadding,
    imageTextSideRowThreePaddingBelowLargeScreen,
    rowThreeHeader,
    rowThreeBody,
    rowThreeImageLink,
    rowThreeImageAltText
}: PatternThreeAlternatingImageTextProps) => {
    const imageWidthValue = imageWidth ?? "550px";
    const rowLayoutPaddingValue = rowLayoutPadding ?? "16px";

    const imageTextSideRowOnePaddingValue =
        imageTextSideRowOnePadding ?? "64px 0 16px";
    const imageTextSideRowOnePaddingBelowLargeScreenValue =
        imageTextSideRowOnePaddingBelowLargeScreen ?? "64px 0 16px";

    const imageTextSideRowTwoPaddingValue =
        imageTextSideRowTwoPadding ?? "32px 0";
    const imageTextSideRowTwoPaddingBelowLargeScreenValue =
        imageTextSideRowTwoPaddingBelowLargeScreen ?? "16px 0";

    const imageTextSideRowThreePaddingValue =
        imageTextSideRowThreePadding ?? "16px 0 64px";
    const imageTextSideRowThreePaddingBelowLargeScreenValue =
        imageTextSideRowThreePaddingBelowLargeScreen ?? "16px 0 64px";

    const ThreeAlternatingImageTextStyles = css({
        ".background-side-by-side": {
            backgroundColor: backgroundColor,
            backgroundImage: backgroundImage
        },
        ".row-layout": {
            "padding": rowLayoutPaddingValue,
            "width": "100%",
            "maxWidth": "1200px",
            "@media (max-width: 767.98px)": {
                width: "100%",
                margin: "0px"
            }
        },
        "img": {
            "width": imageWidthValue,
            "@media (max-width: 767.98px)": {
                order: 0,
                display: "block",
                marginInlineStart: "auto",
                marginInlineEnd: "auto"
            }
        },
        ".text-section": {
            "@media (min-width: 768px)": {
                maxWidth: "568px"
            },
            "h2": {
                "color": "#253858",
                "fontSize": "2.25rem",
                "margin": "0 0 24px ",
                "lineHeight": "1.33",
                "@media (max-width: 767.98px)": {
                    fontSize: "1.5rem",
                    margin: "0 0 14px "
                }
            },
            "hr": {
                margin: "0 0 40px",
                border: 0,
                backgroundColor: horizontalRuleColor
            },
            "p": {
                "color": "#091e42",
                "margin-bottom": 0
            }
        },
        ".image-text-side-row-1": {
            "padding": imageTextSideRowOnePaddingValue,
            "@media (max-width: 767.98px)": {
                padding: imageTextSideRowOnePaddingBelowLargeScreenValue
            }
        },
        ".image-text-side-row-2": {
            "padding": imageTextSideRowTwoPaddingValue,
            "@media (max-width: 767.98px)": {
                padding: imageTextSideRowTwoPaddingBelowLargeScreenValue
            }
        },
        ".image-text-side-row-3": {
            "padding": imageTextSideRowThreePaddingValue,
            "@media (max-width: 767.98px)": {
                padding: imageTextSideRowThreePaddingBelowLargeScreenValue
            }
        }
    });

    return (
        <section css={ThreeAlternatingImageTextStyles}>
            <div className="background-side-by-side">
                <SimpleImageTextSide
                    headerText={rowOneHeader}
                    bodyText={rowOneBody}
                    imageLink={rowOneImageLink}
                    imageAltText={rowOneImageAltText}
                    imagePosition="left"
                    horizontalRule={true}
                    className="image-text-side-row-1"
                />
                <SimpleImageTextSide
                    headerText={rowTwoHeader}
                    bodyText={rowTwoBody}
                    imageLink={rowTwoImageLink}
                    imageAltText={rowTwoImageAltText}
                    horizontalRule={true}
                    className="image-text-side-row-2"
                />
                <SimpleImageTextSide
                    headerText={rowThreeHeader}
                    bodyText={rowThreeBody}
                    imageLink={rowThreeImageLink}
                    imageAltText={rowThreeImageAltText}
                    imagePosition="left"
                    horizontalRule={true}
                    className="image-text-side-row-3"
                />
            </div>
        </section>
    );
};

export default ThreeAlternatingImageText;
